/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('taxLegendCtrl', taxLegendCtrl)
        .controller('newTaxLegendCtrl', newTaxLegendCtrl)
        .controller('editTaxLegendCtrl', editTaxLegendCtrl)
        .controller('deleteTaxLegendController', deleteTaxLegendController);

    taxLegendCtrl.$inject = ['taxLegends','linkService'];
    newTaxLegendCtrl.$inject = ['taxLegendService'];
    editTaxLegendCtrl.$inject = ['taxLegendService','taxLegend','linkService'];
    deleteTaxLegendController.$inject = ['taxLegendService', '$uibModalInstance', '$stateParams'];

    function taxLegendCtrl(taxLegends,linkService) {
        var vm = this;
        vm.linkService = linkService;
        vm.pages = [];
        vm.taxLegends = (taxLegends.data._embedded) ? taxLegends.data._embedded.taxLegends: [];
        vm.pages = taxLegends.data.page;
    }

    function newTaxLegendCtrl(taxLegendService) {
        var vm = this;
        vm.taxLegend = {};

        vm.saveTaxLegend = function(isValid, taxLegend){
            if(isValid){
                taxLegendService.saveTaxLegend(taxLegend);
            }
        }
    }

    function editTaxLegendCtrl(taxLegendService,taxLegend,linkService) {
        var vm = this;
        vm.taxLegend = taxLegend.data;

        vm.saveTaxLegend = function(isValid, taxLegend){
            if(isValid){
                taxLegendService.updateTaxLegend(taxLegend,linkService.getLinkId(taxLegend._links.self.href));
            }
        }
    }

    function deleteTaxLegendController(taxLegendService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.deleteTaxLegend = function(){
            taxLegendService.deleteTaxLegend($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
